import { ViewPluginDetailsModal } from "./ViewPluginDetailsModal";

export default ViewPluginDetailsModal;